import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_LIST_FETCH } from '../../constants/doctorTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorListSchema } from '../../schemas/Normalizr';

export function* doctorListFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  try {
    yield *httpSaga(DOCTOR_LIST_FETCH, call(doctorAPI.all), doctorListSchema);
  } catch (e) {
    yield put(error(DOCTOR_LIST_FETCH, e));
  } finally {
    yield put(doneIndicator(DOCTOR_LIST_FETCH));
  }
}

export function* watchDoctorListFetch() {
  yield takeEvery(DOCTOR_LIST_FETCH, doctorListFetch);
}

export default function* root() {
  yield all([
    fork(watchDoctorListFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorListFetch.js